import React from 'react';

// Emoji Icons for new friendly ranks
const RANK_ICONS = {
  scout: '🔰',
  explorer: '🧭',
  pathfinder: '🗺️',
  trailblazer: '🔥',
  mastermind: '🧠',
  brain_champion: '👑',
};

const RANK_STYLES = {
  scout: {
    bgColor: 'bg-slate-100',
    borderColor: 'border-slate-300',
    textColor: 'text-slate-700',
  },
  explorer: {
    bgColor: 'bg-sky-100',
    borderColor: 'border-sky-400',
    textColor: 'text-sky-800',
  },
  pathfinder: {
    bgColor: 'bg-emerald-100',
    borderColor: 'border-emerald-400',
    textColor: 'text-emerald-800',
  },
  trailblazer: {
    bgColor: 'bg-orange-100',
    borderColor: 'border-orange-400',
    textColor: 'text-orange-800',
  },
  mastermind: {
    bgColor: 'bg-violet-100',
    borderColor: 'border-violet-400',
    textColor: 'text-violet-800',
  },
  brain_champion: {
    bgColor: 'bg-amber-100',
    borderColor: 'border-amber-400',
    textColor: 'text-amber-800',
  }
};

// Main component - shows emoji icon with rank name
const MilitaryRankBadge = ({ rank, size = 'default', showName = true }) => {
  if (!rank) return null;
  
  const icon = RANK_ICONS[rank.id] || '🔰';
  const style = RANK_STYLES[rank.id] || RANK_STYLES.scout;
  
  const sizeClasses = {
    small: {
      container: 'h-7 gap-1.5 px-2 pr-2.5',
      icon: 'text-base',
      text: 'text-xs'
    },
    default: {
      container: 'h-9 gap-2 px-2.5 pr-3',
      icon: 'text-lg',
      text: 'text-sm'
    },
    large: {
      container: 'h-11 gap-2.5 px-3 pr-4',
      icon: 'text-xl',
      text: 'text-base'
    }
  };
  
  const sizes = sizeClasses[size] || sizeClasses.default;
  
  return (
    <div 
      className={`
        inline-flex items-center ${sizes.container} rounded-full
        ${style.bgColor} ${style.textColor}
        border-2 ${style.borderColor}
        shadow-sm
      `}
      data-testid="military-rank-badge"
    >
      <span className={sizes.icon}>{icon}</span>
      {showName && (
        <span className={`font-bold ${sizes.text} whitespace-nowrap`}>
          {rank.name}
        </span>
      )}
    </div>
  );
};

export { RANK_ICONS };

export default MilitaryRankBadge;
